import { FORM_MODES } from 'config/formModes';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';

export const useHasAiWizardOnboarding = () => {
    const hasAiWizardOnboarding = useConfigMatch({ [FEATURE_FLAGS.AI_WIZARD_ONBOARDING]: 'true' });
    const { mode } = useFormFieldValue({});
    return hasAiWizardOnboarding && mode === FORM_MODES.CREATE;
};
